import { Popover, PopoverProps } from "@fluentui/react-components";
import { ETheme, FluentProvider } from "@/dependencies";

interface PopoverCustomProps {
  rcName?: string;
  theme?: ETheme;
  useFluentProvider?: boolean;
}

const PopoverCustom = (props: PopoverCustomProps & PopoverProps) => {
  return (
    <>
      {props.useFluentProvider ? (
        <FluentProvider theme={props.theme}>
          <Popover closeOnScroll {...props} />
        </FluentProvider>
      ) : (
        <Popover closeOnScroll {...props} />
      )}
    </>
  );
};

export default PopoverCustom;
